<template>
  <button :class="[$style.button, {[$style.disabled]: disabled}]" :disabled="disabled" @click="$emit('click')">
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" module>
  .button {
    border: 0;
    cursor: pointer;
    display: inline-block;
    border-radius: 3px;
    border: 1px solid #e4e4e4;
    width: 30px;
    height: 30px;
    padding: 8px;
    svg path,
    svg rect {
      fill: $light-black;
    }

    &.disabled {
      cursor: not-allowed;
      background: $light-gray;

      svg path,
      svg rect {
        fill: $dark-gray;
      }
    }
  }
</style>
